import React from 'react'
import { TimePicker } from "antd"
import moment from 'moment'

export default class RevelTimePicker extends React.Component {

  _onChange = (e, d) => {
    if (this.props.onChange) this.props.onChange(d ? d : '')
  }

  render() {

    return (
      <TimePicker
        format={(this.props.format || "HH:mm")}
        value={(this.props.value ? moment(this.props.value, 'HH:mm') : '')}
        className={(this.props.className || 'form-control')}
        disabled={(this.props.disabled || false)}
        onChange={this._onChange}
      />
    )
  }
}